import { LineItemType } from '../features/select-tickets/cart-types';

type TrackEcommerceType = {
  orderId: string | number;
  total: number;
  tickets: LineItemType[];
  promoCode: string;
  eventCurrency: string;
};

export const trackGtagEvent = (
  action: Gtag.EventNames,
  eventParams?: Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams,
): void => {
  if (typeof gtag === 'undefined') {
    return;
  }

  gtag('event', action, {
    event_label: 'rce_registrations',
    ...eventParams,
  });
};

export const trackMetaPixelEvent = (
  action: string,
  eventParams?: facebook.Pixel.PurchaseParameters,
): void => {
  if (typeof fbq === 'undefined') {
    return;
  }

  fbq('track', action, { ...eventParams });
};

export const trackEcommerce = ({
  orderId,
  total,
  tickets,
  promoCode,
  eventCurrency,
}: TrackEcommerceType): void => {
  trackGtagEvent('purchase', {
    currency: eventCurrency,
    value: total / 100,
    transaction_id: orderId.toString(),
    coupon: promoCode,
    items: tickets.map(ticket => {
      return {
        item_name: ticket.simple_label,
        item_category: 'ticket',
        quantity: ticket.quantity,
        price: ticket.total_price_cents / 100,
      };
    }),
  });
  trackMetaPixelEvent('Purchase', {
    currency: eventCurrency,
    value: total / 100,
    order_id: orderId.toString(),
    num_items: tickets.length,
  });
};
